import { Injectable } from "@angular/core";
import { Coordinate } from "ol/coordinate";
import { Point, Polygon } from "ol/geom";
import { AnalysisQueryPointInterface } from "src/app/modelli/inwit/analisi/query.interface";
import { fromLonLat } from "ol/proj";
import OverlayPositioning from "ol/OverlayPositioning";
import { Overlay } from "ol";
import { AnalysisDataLoaderService } from "src/app/servizi/analysis/analysis-data-loader.service";
import { EbwModalService } from "src/app/library/ebw-modals-angular/ebw-modal.service";
import { AnalysisInterface } from 'src/app/modelli/inwit/analisi/analysis.interface';
import { Subject } from "rxjs";
const namespace_urn = 'G4B';
const collection_urn = 'particle';
const dataset_urn_t = 'INWIT_SISTER_T';
const dataset_urn_b = 'INWIT_SISTER_B';

@Injectable({
  providedIn: 'root',
})
export class AnalysisUtilsService {

  deselectCards$ = new Subject<any>();

  constructor(private analysisDataLoaderService: AnalysisDataLoaderService, private ebwModalService: EbwModalService) { }

  public createRandomName(length: number): string {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  public createAnalysisQueryPoint(analysisId: number, point: Point, crs: number): AnalysisQueryPointInterface {
    const coord = point.getCoordinates();
    const analysisQueryPoint: AnalysisQueryPointInterface = {
      analysis_id: analysisId,
      name: "punto " + this.createRandomName(8),
      active: 1,
      id: null,
      point: {
        crs: {
          type: "name",
          properties: {
            name: `EPSG:${crs}`,
          },
        },
        type: "Point",
        coordinates: coord,
      },
    };

    return analysisQueryPoint;
  }

  public createPointTooltip(tootltip: string, posizione: Coordinate, bgColor: string): Overlay {
     const tooltipElement = document.createElement('div');
     tooltipElement.innerHTML = tootltip;
     tooltipElement.style.cssText = `background-color:${bgColor}; border:1px solid gray; border-radius:10px; font-weight:bold; padding:0px 5px; margin-bottom:2px;`;
     const tooltip = new Overlay({
        element: tooltipElement,
        offset: [0, -7],
        positioning: OverlayPositioning.BOTTOM_CENTER,
        position: posizione
     });
     return tooltip;
  }

  createAnalysisBody(geom4326: Polygon, analysisId: number) {
    const geom = geom4326;
    return {
      id: analysisId,
      type: "Area",
      area: this.createGeojsonPolygonFromPolygonOrCircle(geom, 4326),
    };
  }

  public createGeojsonPolygonFromPolygonOrCircle(geom4326: Polygon, crs:number) {
    
    // console.log(geom4326, crs)
    let polygon = geom4326;
    return {
      type: polygon.getType(),
      coordinates: (polygon as Polygon).getCoordinates(),
      crs: {
        type: "name",
        properties: {
          name: `EPSG:${crs}`,
        },
      },
    };
  }

  public createPoint3857(coord: Coordinate, epsg: number): Point {
    let coords3857 = coord;
    if (epsg != 3857) coords3857 = fromLonLat(coord, "EPSG:3857");
    const point = new Point(coords3857);
    point.set("name", "queryPOINT");
    return point;
  }

  public createPoint4326(coord: Coordinate, epsg: number): Point {
    let coords4326 = coord;
    if (epsg != 4326) coords4326 = fromLonLat(coord, "EPSG:4326");
    const point = new Point(coords4326);
    return point;
  }

  public exportAnalysisCSV(rows) {

    //gestione visualizzazione
    let rows_csv = [];
    let title_csv = [];

    //recupero i titoli
    if (rows.length > 0) {
      let parent = JSON.parse(JSON.stringify(rows[0]));
      
      if(!!rows.map(a => a.holder)){
        let children = rows.map(a => !!a.holder? a.holder: []).filter(r => r.length > 0)[0];//rows.map(a => a.holder).filter(r => r.length > 0)[0]
        delete parent.holder
        let parent_title = Object.keys(parent);
        let children_title = children ? Object.keys(children[0]) : [];
        title_csv = parent_title.concat(children_title);
        rows_csv.push(title_csv);
      }else{
        let parent_title = Object.keys(parent);
        title_csv = parent_title;
        rows_csv.push(title_csv);
      }
    }
    //ciclo per recuperare i dati
    rows.forEach(el => {

      let parent = JSON.parse(JSON.stringify(el));
      
      if(el.holder){
        let children = JSON.parse(JSON.stringify(el.holder));
        delete parent.holder;
        let r1 = Object.values(parent);
        if (children && children.length > 0) {
          children.forEach(bh => {
            let r2 = Object.values(bh)
            let r_concat = r1.concat(r2)
            rows_csv.push(r_concat)
          })
        } else {
          rows_csv.push(r1)
        }
      }else{
        let r1 = Object.values(parent);
        rows_csv.push(r1)
      }

    })

    //export
    let csvContent = "data:text/csv;charset=utf-8," + rows_csv.map(e => e.join(";")).join("\n");
    var encodedUri = encodeURI(csvContent);
    window.open(encodedUri);
  }

  public getUrn(isLand, id) {
    let dataSet = isLand ? dataset_urn_t : dataset_urn_b;
    let urn = namespace_urn + 'refVrecordVdatasetZ' + dataSet + 'VcollectionZ' + collection_urn + 'VkeysZ' + id
    return urn;
  }

  fitQueryPoint(queryPoint: AnalysisQueryPointInterface) {
    if (queryPoint?.point && queryPoint?.id) {
      this.analysisDataLoaderService.broadcastAnalysisQueryPoints({query: [queryPoint], action: 'fit'});
    } else {
      this.ebwModalService.openWarningModal({
        title: "Attenzione",
        content: "Geometria con dati errati",
      });
    }
  }

  removeAllQueryPointsFromMap(){
    this.analysisDataLoaderService.broadcastAnalysisQueryPoints({action:'removeAll',query:[]})
  }

  showAreaOnMap(event: AnalysisInterface) {
    if (event?.area?.crs) {
      const polygon = new Polygon(event.area.coordinates).transform(
        event.area.crs.properties.name,
        "EPSG:3857"
      ) as Polygon;
      this.analysisDataLoaderService.broadcastAnalysisGeometry(polygon);
      this.deselectCards$.next(); 
    }  else {
      this.ebwModalService.openWarningModal({
        title: "Attenzione",
        content: "Geometria con dati errati",
      });
    }
  }

  // (NEW) Per mostrare più poligoni sulla mappa 
  showAreasOnMap(event: any[]) {

    let polygons = [];
    if(!!event && event.length > 0){
      
      event.forEach(analysis => {
        if (analysis?.area?.crs) {

          const polygon = new Polygon(analysis.area.coordinates).transform(
            analysis.area.crs.properties.name,
            "EPSG:3857"
          ) as Polygon;

          // aggiungerne altre?
          polygon.setProperties(
            {
              analysis_id: analysis.analysis_id, 
              nome_sito: analysis.nome_sito
            }
          );
          polygons.push(polygon);
         
        }  else {
          console.error("Geometria con dati errati", analysis);
        }
      })

      this.analysisDataLoaderService.drawAnalysisGeometries(polygons);
    }
    // Pulire Layer
    else {
      this.analysisDataLoaderService.drawAnalysisGeometries(null);
    }
  }

  hideAreaOnMap() {
    this.analysisDataLoaderService.broadcastAnalysisGeometry(null);
  }

}
